export const fonts = `
`;
